import { AlertsAppWebComponent } from './component/AlertsAppWebComponent';
import { WEB_COMPONENT_ALERTS_APP } from '../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_ALERTS_APP, AlertsAppWebComponent);

export { AlertsAppWebComponent };
